import React, { useEffect, useState } from 'react';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import SmallSelect from '../styled/small-select.component';
import useCommonOvcodeUnilab from "../../hooks/useCommonOvcodeUnilab";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 200,
    },
  },
};

export default function ProductMultipleSelectCheckmarks({onProductsChange}) {

  const { getDistinctProducts, distinctProductsData } = useCommonOvcodeUnilab();
  const [products, setProducts] = useState([]);

  useEffect(()=>{
    getDistinctProducts();
  }, []);

  useEffect(()=>{
    if(distinctProductsData.length == 0) return;
    var arr = [
      // distinctProductsData[0].product_name,
      // distinctProductsData[1].product_name,
      // distinctProductsData[2].product_name
    ]
    setProducts(arr);
  }, [distinctProductsData])

  useEffect(()=>{
    if(onProductsChange == null) return;
    var data = [];
    for(var i=0; i < products.length; i++){
      var current_name = products[i];
      for(var i2 = 0; i2 < distinctProductsData.length; i2++){
        if(current_name == distinctProductsData[i2].product_name){
          data.push(distinctProductsData[i2]);
        }
      }
    }
    onProductsChange(data)
  }, [products])

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setProducts(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };

  return (
    <div>
      <FormControl sx={{ minWidth: 80, width: '100%'}}>

        { products.length === 0 ?
          <InputLabel id="demo-multiple-checkbox-label" sx={{color: '#5d5ed8', fontSize: '0.875rem', transform: 'translate(14px, 5px) scale(1)'}}>Products</InputLabel>
        :
          <InputLabel id="demo-multiple-checkbox-label" sx={{color: '#5d5ed8', fontSize: '0.875rem'}}>Products</InputLabel>
        }

        <SmallSelect
            autoWidth
            fontColor={'#5d5ed8'}
            labelId="demo-multiple-checkbox-label"
            id="demo-multiple-checkbox"
            multiple
            value={products}
            onChange={handleChange}
            input={<OutlinedInput label="Products" />}
            renderValue={(selected) => selected.join(', ')}
            MenuProps={MenuProps}
        >
          {distinctProductsData.map((product) => (
            <MenuItem key={product?.product_name} value={product?.product_name}>
              <Checkbox checked={products.indexOf(product?.product_name) > -1} />
              <ListItemText primary={product?.product_name} />
            </MenuItem>
          ))}

        </SmallSelect>
      </FormControl>
    </div>
  );
}